<template>
  <div class="container">
    <div id="text">
      <h1>隐私政策</h1>
      <p>Graph Editor 是一个为 iOS 和 macOS 设计的 Graph 创建和编辑系统。</p>
      <p>此隐私政策适用于主应用本身，其内嵌的框架和应用扩展，以及我们提供的官方示例。但显然不适用于您（用户）自己编写的动作，特别是在使用网络 API 时，请留意（API 服务提供商的）其他可能适用的隐私政策。</p>
      <p class="em">购买项目</p>
      <p>正如我们在定价策略中提到的那样，Graph Editor 为早期用户提供更高的优惠，通过获取应用的购买项目实现。</p>
      <p>此信息包括订阅或购买过的内购项目等，是与用户身份无关的匿名信息，Graph Editor 仅使用其中的 首次下载时间 来判断是否早期支持者。</p>
      <p class="em">iCloud 同步</p>
      <p>Graph Editor 实现了 iCloud 同步的大部分功能，它使用的是苹果提供的 iCloud 服务。可想而知，这个服务是相当安全的，受到全球用户的信赖。</p>
      <p>更重要的是，这与我们的服务没有任何关系，任何数据都不会发送到我们的服务器上。其实上，我们没有针对于数据同步的服务器。</p>
      <p class="em">Graph Editor 收集的数据</p>
      <p>简而言之，Graph Editor 应用程序本身不会收集您的任何数据。是的，我们不会为实现增长的目的而使用任何数据跟踪技术，甚至不会计算拥有多少用户。我们只是想提供一个安全的文本处理环境，而不关心我们的用户规模，或是我们的应用是如何被用户使用的。</p>
      <p>但是您应该谨慎地对待一些可能会请求您数据的 API，例如位置、日历和提醒。尤其是对于第三方分享的动作，请在运行前仔细检查它。</p>
      <p>除此之外，请对我们的服务充满信心，所有隐私信息永远保留在您的设备上，我们无法控制它。</p>
      <p class="em">Cookies</p>
      <p>Cookies 是具有少量数据的文件，通常用作匿名唯一标识符。这些信息将从您访问的网站发送到浏览器，并存储在设备中。</p>
      <p>Graph Editor 不会显式使用 Cookie 技术。但我们用到的第三方代码或网页可能收集 Cookie 以改善其服务，您可以选择接受还是拒绝这些 Cookie，并知道何时将 Cookie 发送到您的设备。</p>
      <p class="em">本隐私政策的变更</p>
      <p>我们可能会不时地更新我们的隐私政策。因此，建议您定期查看此页面以了解更新后的内容。我们会通过在此页面上发布新的隐私政策来通知您任何更改。这些更改在此页面上发布后立即生效。</p>
      <p class="em">联系我们</p>
      <p>如果您对我们的隐私政策有任何疑问或建议，请随时通过 askrsw@163.com 与我们联系。</p>
    </div>
    <div id="location">
      <label>中国·山东</label>
    </div>
    <div id="copyright">
      <label>Copyright &copy; 2022 Haharsw</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GraphEditorUserPolicyZh'
}
</script>

<style scoped>
.container {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 20px;
}
#text {
  margin: 0 auto;
  font-weight: normal;
  font-size: 20px;
  margin-top: 40px;
  margin-bottom: 20px;
  max-width: 800px;
  text-align: left;
}
#text p {
  margin: 0 auto;
  margin-top: 10px;
}
.em {
  font-weight: bold;
  font-size: 25px;
  margin-top: 15px;
}
.clear{ clear:both}
#location {
  font-weight: normal;
  font-size: 16px;
  margin-top: 60px;
  margin-bottom: 10px;
  text-align: center;
}
#copyright {
  font-weight: normal;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 40px;
  text-align: center;
}
</style>
